import { memo } from 'react';

import { HighlightedTextProps } from 'interfaces';

function getHighlightedText(firstWord: string, secondWord: string) {
  const highlight = findLongestSubstring(firstWord, secondWord);

  if (highlight.length < 2) {
    return <span>{firstWord}</span>;
  }
  // Split text on highlight term, include term itself into parts, ignore case
  const parts = firstWord.split(new RegExp(`(${highlight})`, 'gi'));
  return (
    <span>
      {parts.map((part, index) =>
        part.toLowerCase() === highlight.toLowerCase() ? (
          <b key={`${index}-${part}`}>{part}</b>
        ) : (
          part
        )
      )}
    </span>
  );
}

function findLongestSubstring(firstWord: string, secondWord: string) {
  const firstWordLength = firstWord.length;
  const secondWordLength = secondWord.length;

  // Initialize a 2D array to store lengths of longest common suffixes
  const longestCommonSuffixes: number[][] = (() => {
    return Array.from<number[], number[]>({ length: firstWordLength + 1 }, () =>
      Array<number>(secondWordLength + 1).fill(0)
    );
  })();

  let maxLength = 0;
  let endIndex = 0;

  for (let i = 1; i <= firstWordLength; i++) {
    for (let j = 1; j <= secondWordLength; j++) {
      if (firstWord[i - 1] === secondWord[j - 1]) {
        // If characters match, increment the length of the common substring
        longestCommonSuffixes[i][j] = longestCommonSuffixes[i - 1][j - 1] + 1;

        // Update maxLength and endIndex if a longer common substring is found
        if (longestCommonSuffixes[i][j] > maxLength) {
          maxLength = longestCommonSuffixes[i][j];
          endIndex = i - 1;
        }
      } else {
        // Reset the length of the common substring
        longestCommonSuffixes[i][j] = 0;
      }
    }
  }

  // Extract the longest substring from firstWord using the endIndex and maxLength
  return firstWord.substring(endIndex - maxLength + 1, endIndex + 1);
}

const HighlightedText = memo(function HighlightedText({
  firstWord,
  secondWord,
}: HighlightedTextProps) {
  const highlightedText = getHighlightedText(firstWord, secondWord);

  return <div>{highlightedText}</div>;
});

export default HighlightedText;
